import React, {
  FC, MouseEvent, useEffect, useRef, useState
} from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PanelComponent, {
  PanelSectionComponent,
  PanelSubSectionComponent
} from '../../../core/components/panel/PanelComponent';
import TextareaComponent from '../../../core/components/textarea/TextareaComponent';
import TextSettingsContainer from '../../textSettings/TextSettingsContainer';
import ImageSettingsContainer from '../../imageSettings/ImageSettingsContainer';
import DownloadTextContainer from './DownloadTextContainer';
import TextRecognitionContainer from '../../textRecognition/TextRecognitionContainer';
import { resetTextSettingsAction } from '../../textSettings/state/actions';
import { defaultTextSettings } from '../../textSettings/state/reducer';
import { defaultImageSettings } from '../../imageSettings/state/reducer';
import { resetImageSettingsAction } from '../../imageSettings/state/actions';
import ButtonComponent from '../../../core/components/button/ButtonComponent';
import { fontCreatorPageUrl } from '../../../helpers/urls';
import PageLoaderComponent from '../../../core/components/pageLoader/PageLoaderComponent';
import styles from './asideContainer.module.css';

type PropsType = {
  text: string;
  onChangeText: (value: string) => void;
};

const AsideContainer: FC<PropsType> = ({ text, onChangeText }) => {
  const dispatch = useDispatch();
  const [isDownload, setIsDownload] = useState(false);

  const onResetTextSettings = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    dispatch(resetTextSettingsAction(defaultTextSettings));
  };

  const onResetImageSettings = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    dispatch(resetImageSettingsAction(defaultImageSettings));
  };

  const refAd = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (refAd) {
      // @ts-ignore
      window.yaContextCb.push(() => {
        // @ts-ignore
        Ya.Context.AdvManager.render({
          blockId: 'R-A-3642064-3',
          renderTo: 'yandex_rtb_R-A-3642064-3'
        });
      });
    }
  }, [refAd]);

  return (
        <>
            <PanelComponent>
                <PanelSectionComponent>
                    <h4>
                        Распознавание текста
                        <sup style={{ color: '#f16161', fontSize: 10 }}>beta</sup>
                    </h4>
                    <TextRecognitionContainer value={text} onChangeText={onChangeText} />
                </PanelSectionComponent>
                <PanelSectionComponent>
                    <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Настройки текста
                        <a href="#" style={{ fontSize: '13px', color: '#d45252' }} onClick={onResetTextSettings}>
                            Сбросить настройки
                        </a>
                    </h4>
                    <PanelSubSectionComponent>
                        <TextareaComponent value={text} onChange={onChangeText} placeholder="Вставьте текст конспекта" />
                    </PanelSubSectionComponent>
                    <div className={classNames('mb-15', styles.ad)} ref={refAd} id="yandex_rtb_R-A-3642064-3"></div>
                    <TextSettingsContainer />
                </PanelSectionComponent>
                <PanelSectionComponent>
                    <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Настройки изображения
                        <a href="#" style={{ fontSize: '13px', color: '#d45252' }} onClick={onResetImageSettings}>
                            Сбросить настройки
                        </a>
                    </h4>
                    <ImageSettingsContainer />
                </PanelSectionComponent>
                <PanelSectionComponent isSticky>
                    <DownloadTextContainer setIsDownload={setIsDownload} />
                    <Link to={fontCreatorPageUrl} className="block mt-8">
                        <ButtonComponent text="Создать рукописный шрифт" isOutline />
                    </Link>
                </PanelSectionComponent>
            </PanelComponent>
            {isDownload && (
                <PageLoaderComponent>
                    Выполняется генерация конспекта<br />
                    Пожалуйста подождите...
                </PageLoaderComponent>
            )}
        </>
  );
};

export default AsideContainer;
